import { State, Action, MetricsType, MetricsByType } from "./types";
import { composeSiteProperties } from "./utils";

export function reducer(state: State, action: Action): State {
  const actionType = action.type;

  switch (action.type) {
    case "LOAD_SUMMARY":
      return {
        ...state,
        summaryLoading: true,
      };
    case "SUMMARY_REQUEST_SUCCESS": {
      const composed = composeSiteProperties(state, action);
      const sites = new Map(composed.map((s) => [s.siteId, s]));

      return {
        ...state,
        summaryLoading: false,
        summaryLoaded: true,
        sites,
        shouldUpdateSummary: false,
        summary: {
          [MetricsType.Completed]: action[MetricsType.Completed],
          [MetricsType.Opened]: action[MetricsType.Opened],
          [MetricsByType.BySite]: action.bySite,
          [MetricsByType.ByResponsible]: action.byResponsible, // @TODO: currently missing this in API response
        },
      };
    }
    case "SUMMARY_REQUEST_FAIL":
      // @TODO: implement fail state
      return {
        ...state,
        summaryLoading: false,
        summaryLoaded: false,
        shouldUpdateSummary: false,
      };
    case "SET_SHOULD_UPDATE_SUMMARY":
      return {
        ...state,
        shouldUpdateSummary: action.shouldUpdate,
      };
    case "SET_SHOULD_UPDATE_METRICS":
      return {
        ...state,
        shouldUpdateMetrics: action.shouldUpdate,
      };
    case "SET_TIME_FRAME":
      return {
        ...state,
        shouldUpdateSummary: true,
        shouldUpdateMetrics: true,
        timeFrameOption: action.timeFrameOption,
        startDate: action.startDate,
        endDate: action.endDate,
      };
    case "SET_SORTING_DIRECTION":
      return {
        ...state,
        sortingDirection: action.sortingDirection,
      };
    case "SET_SITES_LIST":
      return {
        ...state,
        shouldUpdateSummary: true,
        shouldUpdateMetrics: true,
        sites: new Map(action.sites.map((s) => [s.siteId, s])),
        active: new Set(action.sites.map((s) => s.siteId)),
      };
    case "ADD_RESPONSIBLE":
      const added = [
        ...state.metrics.pinnedResponsibleList,
        action.responsible,
      ];
      return {
        ...state,
        metrics: {
          ...state.metrics,
          pinnedResponsibleList: [...new Set(added)],
        },
      };
    case "REMOVE_RESPONSIBLE":
      const removed = [...state.metrics.pinnedResponsibleList];
      const index = removed.indexOf(action.responsible);
      if (index > -1) {
        removed.splice(index, 1);
      }
      return {
        ...state,
        metrics: {
          ...state.metrics,
          pinnedResponsibleList: [...new Set(removed)],
        },
      };
    case "LOAD_METRICS":
      return {
        ...state,
        metricsLoading: true,
      };
    case "METRICS_REQUEST_SUCCESS":
      return {
        ...state,
        shouldUpdateMetrics: false,
        metricsLoading: false,
        metricsLoaded: true,
        metrics: {
          ...state.metrics,
          currentMetricsType: action.metricsType,
          pinnedResponsibleList: [],
          [action.metricsType]: {
            total: action.total,
            [MetricsByType.BySite]: action.bySite,
            [MetricsByType.ByResponsible]: action.byResponsible,
          },
        },
      };
    case "SET_METRICS_BY_TYPE":
      return {
        ...state,
        byType: action.by,
      };
    case "METRICS_REQUEST_FAIL":
      // @TODO: implement fail state
      return {
        ...state,
        metricsLoading: false,
        metricsLoaded: false,
        shouldUpdateMetrics: false,
      };
    default:
      throw new Error(`Unhandled action type: ${actionType}`);
  }
}
